import { Block } from '../schema';

export default function imagePreviewDimensionsNeedSync(block: Block) {
  if (block.type !== 'image') {
    return false;
  }
  const url = block.props.url;
  if (typeof url !== 'string' || !url.trim()) {
    return false;
  }
  const previewWidth = block.props.previewWidth;
  return !(
    typeof previewWidth === 'number' &&
    Number.isFinite(previewWidth) &&
    previewWidth > 0
  );
}
